import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { ErrMsg } from './index'
import styled from 'styled-components'

const StyledInput = styled(Input)`
  height: 40px;
  font-size: 16px;
  
  @media (max-width: 768px) {
    height: 45px;
    font-size: 16px; /* ป้องกัน zoom บน iOS */
  }
`

export const TextInput = (props) => (
    <React.Fragment>
        <StyledInput {...props} />
        {props.errors[props.name] && <ErrMsg>{props.errors[props.name]}</ErrMsg>}
    </React.Fragment>
)

TextInput.defaultProps = {
    errors: {},
}

TextInput.propTypes = {
    errors: PropTypes.object,
}
